import * as actionTypes from "./TicketsTypes";

const INITIAL_STATE = {
    projectListForTkt: [],
    subProjectFilterList: [],
    issueTypeList: [],
    ticketList: null,
    ticketColumnList: [],
    userTicketColumnList: [],
    ticketCountList: [],
    userDefaultList: [],
    agentList: [],
    replyMailList: [],
    closedEmailContent: [],
    delayedReasonList: [],
    ticketDetail: null,
    basicFilterData: [],
    agedTicketReviewList: [],
    ticketResolutionData: {},
    rootCauseList: [],
};

const SDTicketsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETPRJLISTFORTKT:
            return {
                ...state,
                projectListForTkt: action.payload.list,
            };
        case actionTypes.SETSUBPRJLIST:
            return {
                ...state,
                subProjectFilterList: action.payload.list,
            };
        case actionTypes.SETISSUETYPELIST:
            return {
                ...state,
                issueTypeList: action.payload.list,
            };
        case actionTypes.SETTICKETLIST:
            return {
                ...state,
                ticketList: action.payload.list,
            };
        case actionTypes.SETDELAYEDREASONLIST:
            return {
                ...state,
                delayedReasonList: action.payload.list,
            };
        case actionTypes.SETAGEDTICKETREVIEWLIST:
            return {
                ...state,
                agedTicketReviewList: action.payload.list,
            };
        case actionTypes.CLEARDOC:
            return {
                ...state,
                ticketDetail: null, subProjectFilterList: null, issueTypeList: null
            };
        case actionTypes.SETTICKETDETAIL:
            return {
                ...state,
                ticketDetail: action.payload.list
            };
        case actionTypes.SETTKTCOLUMNLIST:
            return {
                ...state,
                ticketColumnList: action.payload.list
            };
        case actionTypes.SETUSERTKTCOLUMNLIST:
            return {
                ...state,
                userTicketColumnList: action.payload.list
            };
        case actionTypes.SETUSERDEFAULTLIST:
            return {
                ...state,
                userDefaultList: action.payload.list
            };
        case actionTypes.SETTICKETCOUNTLIST:
            return {
                ...state,
                ticketCountList: action.payload.list,
            };
        case actionTypes.SETAGENTLIST:
            return {
                ...state,
                agentList: action.payload.list,
            };
        case actionTypes.SETREPLYMAILLIST:
            return {
                ...state,
                replyMailList: action.payload.list,
            };
        case actionTypes.SETCLOSEDEMAILCONTENT:
            return {
                ...state,
                closedEmailContent: action.payload.list,
            };
        case actionTypes.SETUSERREVIEWEMAILCONTENT:
            return {
                ...state,
                userReviewEmailContent: action.payload.list,
            };
        case actionTypes.SETTICKETSBASICFILTERDATA:
            return {
                ...state,
                basicFilterData: { ...action.payload }
            };
        case actionTypes.SET_RESOLUTION_BY_TICKET_ID:
            return {
                ...state,
                ticketResolutionData: action.payload.list,
            };
        case actionTypes.SET_ALL_ROOT_CAUSES:
            return {
                ...state,
                rootCauseList: action.payload.list,
            };
        default:
            return state;
    }
};

export default SDTicketsReducer;